import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';
import { ImageSequencePlayer } from '../ImageSequence';

import classes from './ClaimHammerAnimation.module.scss';

export const ClaimHammerAnimation = observer(() => {
  const { hammersStore } = useStores();
  const { hammerAnimationState, frameLoaded } = hammersStore;

  if (!frameLoaded || !hammerAnimationState.enable) {
    return null;
  }

  return (
    <div className={classes.claimHammerAnimation}>
      <ImageSequencePlayer
        enabled={true}
        fps={35}
        frames={hammersStore.claimHammersFrames}
        loopCount={0}
        style={{ width: '100%' }}
        onFrameChange={({ frameIndex }) => {
          if (frameIndex === 32) {
            hammerAnimationState.onAnimationEnd?.();
          }
        }}
      />
      <div className={classes.claimHammerAnimationCount}>+{hammerAnimationState.hammerAmount}</div>
    </div>
  );
});
